import type { MathTask } from "~/types/article"
import type { MathTaskIbexa } from "~/models/Content/schemas"
import { ContentType } from "~/models/Content/ContentType"

export default (
  articleId: number,
  mathTasks: MathTaskIbexa[],
  formatHtml: (html: string) => string,
): MathTask | undefined => {
  const assignments = mathTasks
    .filter(isContentType(ContentType.MathTaskIbexa))
    .map(m => ({
      id: m.locationId,
      type: m.assignmentType ?? "",
      text: formatHtml(m.assignmentText?.html ?? ""),
      priority: m.priority,
    }))
    .sort(byPriority)

  if (!assignments.length) return undefined

  return {
    articleId,
    assignmentType:
      assignments.find(a => a.type.length > 0)?.type ?? "",
    assignments,
  }
}
